import { IonImg, IonText } from '@ionic/react';

import ENVIRONMENT from '@/environments/environment';
import useMediaQuery, { Breakpoint } from '@/hooks/useMediaQuery';
import { openBrowser } from '@/utils/appHelper';

import BannerDots from '../../../assets/imgs/banner-dots.webp';
import BannerHelpBg from '../../../assets/imgs/banner-help.webp';
import BannerLearningBg from '../../../assets/imgs/banner-learning.webp';
import BannerOperationsBg from '../../../assets/imgs/banner-operations.webp';
import BannerProfileBg from '../../../assets/imgs/banner-profile.webp';
import BannerReportingBg from '../../../assets/imgs/banner-reporting.webp';
import DownloadAndroid from '../../../assets/imgs/download-android.svg';
import DownloadIos from '../../../assets/imgs/download-ios.svg';
import styles from './Banner.module.scss';

export enum BannerType {
  REPORTING = 'reporting',
  OPERATIONS = 'operations',
  PROFILE = 'profile',
  LEARNING = 'learning',
  HELP = 'help',
}
export interface BannerProps {
  type: BannerType;
}

export default function Banner({ type }: BannerProps) {
  const handleRedirectStores = (baseUrl: string) => {
    openBrowser(baseUrl, {
      target: '_system',
    });
  };

  const isDesktopLarge = useMediaQuery(Breakpoint.DesktopLarge);

  return (
    <div className={styles.wrapper}>
      <div
        className={styles.container}
      >
        <div className={styles.backgroundContainer}>
          {type === BannerType.REPORTING && <IonImg src={BannerReportingBg} className={styles.bannerImage} />}
          {type === BannerType.OPERATIONS && <IonImg src={BannerOperationsBg} className={styles.bannerImage} />}
          {type === BannerType.HELP && <IonImg src={BannerHelpBg} className={styles.bannerImage} />}
          {type === BannerType.LEARNING && <IonImg src={BannerLearningBg} className={styles.bannerImage} />}
          {type === BannerType.PROFILE && <IonImg src={BannerProfileBg} className={styles.bannerImage} />}
        </div>
        <div className={styles.textContainer}>
          <div className={styles.textSection}>
            <IonText
              color="light"
              className={styles.bannerTitle}
            >
              Descarga la App Pepper Comercios
            </IonText>
          </div>
          <div className={styles.linksSection}>
            <IonImg
              src={DownloadIos}
              className={styles.downloadIos}
              onClick={() => {
                handleRedirectStores(ENVIRONMENT.IOS_DOWNLOAD_LINK!);
              }}
            />
            <IonImg
              src={DownloadAndroid}
              className={styles.downloadAndroid}
              onClick={() => handleRedirectStores(ENVIRONMENT.ANDROID_DOWNLOAD_LINK!)}
            />
          </div>
          {isDesktopLarge
            && <img src={BannerDots} className={styles.dots} alt="dots" />}
        </div>
      </div>
    </div>

  );
}
